/**
 * ISO 3166-1 alpha-2 country list for the CountryGatePage selector.
 * Supported countries are listed first, then the rest sorted alphabetically.
 */

export interface Country {
  code: string;
  name: string;
}

/** Countries where Milo y Lola is currently available */
export const SUPPORTED_COUNTRIES: Country[] = [{ code: 'ES', name: 'España' }];

/** All other countries we want to show in the waitlist dropdown */
export const OTHER_COUNTRIES: Country[] = [
  { code: 'AD', name: 'Andorra' },
  { code: 'DZ', name: 'Argelia' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'BE', name: 'Bélgica' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BR', name: 'Brasil' },
  { code: 'CA', name: 'Canadá' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Croacia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Chipre' },
  { code: 'CZ', name: 'Chequia' },
  { code: 'DK', name: 'Dinamarca' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egipto' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'FI', name: 'Finlandia' },
  { code: 'FR', name: 'Francia' },
  { code: 'DE', name: 'Alemania' },
  { code: 'GR', name: 'Grecia' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HU', name: 'Hungría' },
  { code: 'IS', name: 'Islandia' },
  { code: 'IE', name: 'Irlanda' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italia' },
  { code: 'JP', name: 'Japón' },
  { code: 'LU', name: 'Luxemburgo' },
  { code: 'MX', name: 'México' },
  { code: 'MA', name: 'Marruecos' },
  { code: 'NL', name: 'Países Bajos' },
  { code: 'NZ', name: 'Nueva Zelanda' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NO', name: 'Noruega' },
  { code: 'PA', name: 'Panamá' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Perú' },
  { code: 'PH', name: 'Filipinas' },
  { code: 'PL', name: 'Polonia' },
  { code: 'PT', name: 'Portugal' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'RO', name: 'Rumanía' },
  { code: 'SK', name: 'Eslovaquia' },
  { code: 'SI', name: 'Eslovenia' },
  { code: 'ZA', name: 'Sudáfrica' },
  { code: 'KR', name: 'Corea del Sur' },
  { code: 'SE', name: 'Suecia' },
  { code: 'CH', name: 'Suiza' },
  { code: 'TW', name: 'Taiwán' },
  { code: 'TR', name: 'Turquía' },
  { code: 'UA', name: 'Ucrania' },
  { code: 'GB', name: 'Reino Unido' },
  { code: 'US', name: 'Estados Unidos' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'VE', name: 'Venezuela' },
];

/**
 * Full country list: supported countries first (with a visual separator label),
 * then the rest alphabetically sorted.
 */
export const ALL_COUNTRIES: Country[] = [...SUPPORTED_COUNTRIES, ...OTHER_COUNTRIES];
